import {useState} from 'react'
import styled from "styled-components";
import { colors } from "../../styles/variables";
import { IPlanJRW } from "../types";

interface IProps {
  id: string
  name: string
  plans: IPlanJRW[];
  defaultValue: string
  onChange: (event: React.ChangeEvent) => void
}

const StyledSelect = styled.select`
  width: 100%;
  height: 40px;
  background-color: transparent;
  font-size: 16px;
  padding: 4px 16px;
  border: 1px solid ${colors.gray300};
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
  &::placeholder {
    color: ${colors.gray500};
  }
`;

const Select = ({ id, name, plans, defaultValue, onChange }: IProps) => {
  return (
    <StyledSelect id={id} name={name} defaultValue={defaultValue} onChange={onChange}>
      {plans.map((plan) => {
        const { planId, name, adultSellingPrice } = plan;
        return (
          <option key={planId} value={name}>
            {name} | JPY {adultSellingPrice}
          </option>
        );
      })}
    </StyledSelect>
  );
};

export default Select;
